import { Graphics, Sprite } from 'pixi.js';
import type { Renderer } from 'pixi.js';
import { PHYSICS } from './Physics';

export const TEE_WIDTH = 4;
export const TEE_HEIGHT = 16;
export const TEE_COLOR = 0xf5deb3;

export const HOLE_WIDTH = 36;
export const HOLE_DEPTH = 24;
export const HOLE_CAPTURE_SPEED = 20;

export const BALL_COLOR = 0xffffff;
export const BALL_RADIUS = PHYSICS.BALL_RADIUS;

export function createBallSprite(renderer: Renderer): Sprite {
  const gfx = new Graphics();
  gfx.circle(0, 0, BALL_RADIUS);
  gfx.fill(BALL_COLOR);
  const texture = renderer.generateTexture(gfx);
  const sprite = new Sprite(texture);
  sprite.anchor.set(0.5, 0.5);
  return sprite;
}

export function createTeeSprite(renderer: Renderer): Sprite {
  const gfx = new Graphics();
  gfx.rect(0, 0, TEE_WIDTH, TEE_HEIGHT);
  gfx.fill(TEE_COLOR);
  const texture = renderer.generateTexture(gfx);
  const sprite = new Sprite(texture);
  sprite.anchor.set(0.5, 1.0);
  return sprite;
}
